"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function CsvdownloadGreyOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M5.196 9.828a1.132 1.132 0 01-.892-.344c-.22-.28-.33-.632-.308-.988a1.448 1.448 0 01.32-1.004 1.2 1.2 0 01.928-.352c.253-.003.505.049.736.152l-.18.444a1.668 1.668 0 00-.564-.136c-.448 0-.672.296-.672.892-.016.231.043.461.168.656a.588.588 0 00.492.22c.242.004.482-.054.696-.168v.48a1.02 1.02 0 01-.316.124c-.135.022-.272.03-.408.024zM8.272 9.04a.672.672 0 01-.28.584 1.316 1.316 0 01-.8.204c-.286.01-.57-.044-.832-.16V9.2c.266.13.556.203.852.212.34 0 .508-.104.508-.308a.236.236 0 00-.056-.164.68.68 0 00-.184-.136 3.916 3.916 0 00-.36-.16 1.6 1.6 0 01-.604-.344.636.636 0 01-.16-.452.6.6 0 01.268-.516c.22-.134.475-.198.732-.184.298-.002.593.06.864.184l-.176.4a1.916 1.916 0 00-.708-.172c-.288 0-.436.08-.436.248a.248.248 0 00.116.204c.156.096.322.174.496.232.163.059.318.135.464.228a.68.68 0 01.296.568zM9.456 9.78L8.472 7.2h.58l.528 1.508c.076.198.131.403.164.612h.02c.037-.208.092-.413.164-.612l.528-1.508h.584l-.988 2.592-.596-.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M2.6 14.8a.4.4 0 01-.4-.4V1.6a.4.4 0 01.4-.4h6.8v3.2h3.2V8h1.2V3.2L10.6 0h-8A1.6 1.6 0 001 1.6v12.8A1.6 1.6 0 002.6 16h8.756l-1.2-1.2H2.6zm8-13.104L12.104 3.2H10.6V1.696z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M15.344 12.876a.595.595 0 00-.848 0l-.776.776V9.7a.6.6 0 10-1.2 0v3.952l-.776-.776a.6.6 0 10-.848.848l1.8 1.8a.571.571 0 00.636.132.604.604 0 00.196-.132l1.8-1.8a.595.595 0 00.016-.848z"
  }));
}

CsvdownloadGreyOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
CsvdownloadGreyOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = CsvdownloadGreyOutline;
exports["default"] = _default;